var map = {
	"./de-DE.js": [
		70161,
		"node_modules_pnpm_bdeo_webcomponents_5_18_0_node_modules_bdeo_webcomponents_dist_locales_de-DE_js"
	],
	"./el-GR.js": [
		27785,
		"node_modules_pnpm_bdeo_webcomponents_5_18_0_node_modules_bdeo_webcomponents_dist_locales_el-GR_js"
	],
	"./es-ES.js": [
		2667,
		"node_modules_pnpm_bdeo_webcomponents_5_18_0_node_modules_bdeo_webcomponents_dist_locales_es-ES_js"
	],
	"./es-MX.js": [
		27742,
		"node_modules_pnpm_bdeo_webcomponents_5_18_0_node_modules_bdeo_webcomponents_dist_locales_es-MX_js"
	],
	"./fr-FR.js": [
		60423,
		"node_modules_pnpm_bdeo_webcomponents_5_18_0_node_modules_bdeo_webcomponents_dist_locales_fr-FR_js"
	],
	"./it-IT.js": [
		1905,
		"node_modules_pnpm_bdeo_webcomponents_5_18_0_node_modules_bdeo_webcomponents_dist_locales_it-IT_js"
	],
	"./pt-BR.js": [
		3907,
		"node_modules_pnpm_bdeo_webcomponents_5_18_0_node_modules_bdeo_webcomponents_dist_locales_pt-BR_js"
	],
	"./pt-PT.js": [
		42939,
		"node_modules_pnpm_bdeo_webcomponents_5_18_0_node_modules_bdeo_webcomponents_dist_locales_pt-PT_js"
	],
	"./th-TH.js": [
		5371,
		"node_modules_pnpm_bdeo_webcomponents_5_18_0_node_modules_bdeo_webcomponents_dist_locales_th-TH_js"
	],
	"./tr-TR.js": [
		95003,
		"node_modules_pnpm_bdeo_webcomponents_5_18_0_node_modules_bdeo_webcomponents_dist_locales_tr-TR_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 85487;
module.exports = webpackAsyncContext;